import React from 'react';
import FlowContext from './context/FlowContext';

export default class WithFlowComponent extends React.Component {
    static contextType = FlowContext

    constructor(props) {
        super(props);
    }

    render() {
        const { ...passProps } = this.props;

        return (
            this.props.children({
                ...passProps,
            })
        );
    }
}
